import { render } from "./PreviewTab.vue?vue&type=template&id=a4710f4a&scoped=true"
import script from "./PreviewTab.vue?vue&type=script&lang=js"
export * from "./PreviewTab.vue?vue&type=script&lang=js"

import "./PreviewTab.css?vue&type=style&index=0&id=a4710f4a&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4710f4a"]])

export default __exports__